@if (files(); as files) {
  <table
    #table
    mat-table
    [dataSource]="files"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell class="custom-table-header" *matHeaderCellDef>{{ 'TABLE.HEADERS.NAME' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex items-end gap-2">
          @if (element.type === FileType.FOLDER) {
            <mat-icon class="material-symbols-outlined">folder</mat-icon>
          }

          @if (element.type === FileType.FILE) {
            <mat-icon class="material-symbols-outlined">description</mat-icon>
          }

          @if (canBeDownloaded(element)) {
          <span
            [class.cursor-pointer]="canBeDownloaded(element)"
            [class.text-blue-600]="canBeDownloaded(element)"
            (click)="openPreview(element)"
          >
            {{ element.name }}
          </span>
          } @else {
            <span>
            {{ element.name }}
          </span>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell class="custom-table-header" *matHeaderCellDef>{{ 'TABLE.HEADERS.SIZE' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ (element.size / 1024 / 1024 | number: '0.2-2') + ' MB' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="author">
      <th mat-header-cell class="custom-table-header" *matHeaderCellDef>{{ 'TABLE.HEADERS.AUTHOR' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.author }}
      </td>
    </ng-container>

    <ng-container matColumnDef="uploadDate">
      <th mat-header-cell class="custom-table-header" *matHeaderCellDef>{{ 'TABLE.HEADERS.UPLOAD_DATE' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element.createdAt | date: 'dd/MM/yyyy'  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell class="custom-table-header" *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="pl-0 pr-0 w-px">
        <button
          mat-icon-button
          [matMenuTriggerFor]="menu"
        >
          <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" class="custom-mat-menu">
          <button mat-menu-item (click)="openDeleteConfirmDialog(element)"
          >
            <span>{{ 'TABLE.BUTTONS.DELETE' | translate }}</span>
          </button>
          <button mat-menu-item (click)="onDownloadClick(storageStateService.folderId(), element.id, element.name)">
            <span>{{ 'TABLE.BUTTONS.DOWNLOAD' | translate }}</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  @if (files.length == 0) {
    <div class="p-4 text-center text-gray-500">
      {{ 'TABLE.NO_DATA' | translate }}
    </div>  }
}
